
export default {
  data() {
    return {
      activeId: null,
      sectionId: null,

      options: [
        {
          name: "title",
          label: "Naslov",
          type: "text",
        },
        {
          name: "shortDescription",
          label: "Kratki opis",
          type: "text",
        },

        {
          name: "image",
          label: "Slika",
          type: "image",
          size: "361x240",
        },
      ],

      optionsIngredients: [
        {
          name: "title",
          label: "Naslov",
          type: "text",
        },
      ],
      optionsInfo: [
        {
          name: "info1",
          label: "Informacija 1",
          type: "text",
        },
        {
          name: "info2",
          label: "Informacija 2",
          type: "text",
        },
        {
          name: "info3",
          label: "Informacija 3",
          type: "text",
        },
      ],
    };
  },
  mounted() {
    if (this.$refs.sectionId.$el && this.$refs.sectionId.$el.outerText) {
      this.sectionId = this.$refs.sectionId.$el.outerText;
    }

    this.$nextTick(() => {
      this.$isInViewport(this.sectionId);
    });
  },
  methods: {
    setActiveId(id) {
      let idScroll;

      if (id) {
        this.activeId = id;
        idScroll = `activeProduct_${this.sectionId}`;
      } else {
        setTimeout(() => {
          this.activeId = null;
        }, 300);

        idScroll = this.sectionId;
      }

      const el = document.getElementById(idScroll);

      if (el) {
        setTimeout(() => {
          el.scrollIntoView();
        }, 100);
      }
    },
  },
};
